import { rem } from 'polished'
import styled from 'styled-components'

export const ImporterCriteriaContainerStyled = styled.div`
  font-size: ${rem(16)};

  text-align: left;
`
